goog.provide("shadow.js.shim.module$src$svg$controls$target_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$target_svg");
shadow.js.shim.module$src$svg$controls$target_svg = shadow.js.nativeProvides["src/svg/controls/target.svg"] = shadow$bridge("src/svg/controls/target.svg");
module$shadow_js_shim_module$src$svg$controls$target_svg.default = shadow.js.shim.module$src$svg$controls$target_svg;
